var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "hv-product-youtube-tv productVideoWrapper" }, [
      _vm.propUrl.length > 0
        ? _c("div", { staticClass: "video-modal productVideoBtn" }, [
            _c("div", { staticClass: "video-container" }, [
              _c("iframe", {
                attrs: {
                  id: "productVideoiFrame",
                  height: "100%",
                  width: "100%",
                  src: _vm.propUrl + "?rel=0&enablejsapi=1",
                  frameborder: "0",
                  allowfullscreen: "allowfullscreen",
                },
              }),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }